import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IEventsCsvLinkResult {
  fetch: {
    Events: string;
  };
}

export type WithEventsCsvLinkQueryProps = QueryResult<IEventsCsvLinkResult>;

class EventsCsvLinkQuery extends Query<IEventsCsvLinkResult> {}

const withEventsCsvLinkQuery = <P extends WithEventsCsvLinkQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, WithEventsCsvLinkQueryProps>> => props => {
  return (
    <EventsCsvLinkQuery query={queries.GET_EVENTS_CSV_LINK}>
      {providedProps => <Component {...providedProps} {...props as any} />}
    </EventsCsvLinkQuery>
  );
};

export default withEventsCsvLinkQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withEventsCsvLink.tsx